/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupButtonDropdown,
    InputGroupText
} from 'reactstrap';
import {i18n} from "../../language/i18n";
import {isURL, isValueEmpty} from "../../utils";
import {connect} from "react-redux";
import HearFacebookButtonPayloads from "./HearFacebookButtonPayloads";

class HearFacebookButton extends Component {

    static CALLBACK_GET_STARTED = "get_started";
    static CALLBACK_ADMIN_CHAT = "USER_PICK_OPTION_CHAT_WITH_ADMIN";

    static WEB_LINK = "web_url";
    static POSTBACK = "postback";

    static ATTRIBUTE_TEXT = "text";
    static ATTRIBUTE_URL = "url";
    static ATTRIBUTE_TYPE = "type";
    static ATTRIBUTE_PAYLOAD = "payload";

    constructor(props) {
        super(props);
        const {buttonIndex} = this.props;

        this.toggleButtonType = this.toggleButtonType.bind(this);
        this.selectButtonType = this.selectButtonType.bind(this);

        this.toggleCallback = this.toggleCallback.bind(this);
        this.selectCallback = this.selectCallback.bind(this);

        this.buttonNumber = buttonIndex + 1;

        const {buttonData} = this.props;

        let url = "";
        let text = "";
        let type = HearFacebookButton.WEB_LINK;
        let payload = HearFacebookButton.CALLBACK_GET_STARTED;

        if (buttonData !== undefined && buttonData !== null) {
            url = buttonData.url === undefined ? "" : buttonData.url;
            text = buttonData.text === undefined ? "" : buttonData.text;
            type = buttonData.type === undefined ? HearFacebookButton.WEB_LINK : buttonData.type;
            payload = buttonData.payload === undefined ? HearFacebookButton.CALLBACK_GET_STARTED : buttonData.payload;
        }

        url = url == null ? "" : url;
        text = text == null ? "" : text;
        type = type == null ? HearFacebookButton.WEB_LINK : type;
        payload = payload == null ? HearFacebookButton.CALLBACK_GET_STARTED : payload;

        this.loopHears = [];

        this.state = {
            buttonType: type,
            buttonText: text,
            buttonUrl: url,
            buttonPayload: payload,

            buttonTextValid: false,
            buttonTextInvalid: false,

            buttonUrlValid: false,
            buttonUrlInvalid: false,

            dropdownOpen: false,
            dropdownCallbackOpen: false,
            hears: [],
        };
    }

    loopHearAdd(id) {
        this.loopHears.push(id);
    }

    loopHearExist(id) {
        return this.loopHears.indexOf(id) > -1;
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.loopHears = [];
        // console.log(nextProps);

        let buttonData = nextProps.buttonData;

        let url = "";
        let text = "";
        let type = HearFacebookButton.WEB_LINK;
        let payload = HearFacebookButton.CALLBACK_GET_STARTED;

        if (buttonData !== undefined && buttonData !== null) {
            url = buttonData.url === undefined ? "" : buttonData.url;
            text = buttonData.text === undefined ? "" : buttonData.text;
            type = buttonData.type === undefined ? HearFacebookButton.WEB_LINK : buttonData.type;
            payload = buttonData.payload === undefined ? HearFacebookButton.CALLBACK_GET_STARTED : buttonData.payload;
        }

        url = url == null ? "" : url;
        text = text == null ? "" : text;
        type = type == null ? HearFacebookButton.WEB_LINK : type;
        payload = payload == null ? HearFacebookButton.CALLBACK_GET_STARTED : payload;

        this.setState({
            buttonType: type,
            buttonText: text,
            buttonUrl: url,
            buttonPayload: payload,

            buttonTextValid: false,
            buttonTextInvalid: false,

            buttonUrlValid: false,
            buttonUrlInvalid: false,
        })
    }


    handleTextChange = (event) => {
        this.setState({buttonText: event.target.value}, this.updateButton);
    };

    handleUrlChange = (event) => {
        this.setState({buttonUrl: event.target.value}, this.updateButton);
    };

    selectButtonType(event) {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
            buttonType: event.target.value,
        }, this.updateButton);
    }

    selectCallback = (event) => {
        this.setState({
            dropdownCallbackOpen: false,
            buttonPayload: event.target.value,
        }, this.updateButton);
    };

    updateButton() {
        let buttonIndex = this.props.buttonIndex;
        let readyToUpdate = true;

        if (isValueEmpty(this.state.buttonType)) readyToUpdate = false;

        if (isValueEmpty(this.state.buttonText)) {
            readyToUpdate = false;
            this.setState({buttonTextValid: false, buttonTextInvalid: true});
        } else {
            this.setState({buttonTextValid: true, buttonTextInvalid: false});
        }

        if (!this.isUrlButtonValid(this.state)) readyToUpdate = false;
        if (isValueEmpty(this.state.buttonPayload) && !isURL(this.state.buttonUrl)) readyToUpdate = false;

        if (readyToUpdate) {

            let buttonData = {};
            buttonData[HearFacebookButton.ATTRIBUTE_TYPE] = this.state.buttonType;
            buttonData[HearFacebookButton.ATTRIBUTE_TEXT] = this.state.buttonText;
            buttonData[HearFacebookButton.ATTRIBUTE_URL] = this.state.buttonUrl;
            buttonData[HearFacebookButton.ATTRIBUTE_PAYLOAD] = this.state.buttonPayload;

            this.props.hearButtons.updateButtons(buttonIndex, buttonData);
            return;
        }

        //this.props.hearButtons.deleteButtons(buttonIndex);
    }

    isUrlButtonValid(state) {
        if (state.buttonType !== HearFacebookButton.WEB_LINK) {
            return true;
        }

        if (isURL(state.buttonUrl)) {
            this.setState({buttonUrlValid: true, buttonUrlInvalid: false});
            return true;
        }

        this.setState({buttonUrlValid: false, buttonUrlInvalid: true});
        return false;
    }

    toggleButtonType() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }

    toggleCallback() {
        this.setState({
            dropdownCallbackOpen: !this.state.dropdownCallbackOpen,
        });
    }

    callbackString(data) {
        let list = [];
        list[HearFacebookButton.CALLBACK_GET_STARTED] = i18n.t("Get Started");
        list[HearFacebookButton.CALLBACK_ADMIN_CHAT] = i18n.t("Chat với Admin");
        if (list[data]) return list[data];
        return data;
    }

    typeString(data) {
        let list = [];
        list[HearFacebookButton.WEB_LINK] = i18n.t("Web URL");
        list[HearFacebookButton.POSTBACK] = i18n.t("Postback");

        if (list[data]) return list[data];
        return data;
    }

    createInputUrl = () => {
        return (
            <div className="api-input-item">
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>{i18n.t("Action") + " " + this.buttonNumber}</InputGroupText>
                    </InputGroupAddon>
                    <Input
                        placeholder="https://..."
                        id={'button_url_' + this.props.replyIndex + '_' + this.props.buttonIndex}
                        onChange={this.handleUrlChange}
                        value={this.state.buttonUrl}
                        invalid={this.state.buttonUrlInvalid}
                        valid={this.state.buttonUrlValid}
                    />
                </InputGroup>
            </div>
        );
    };

    dropdownHears = (component, props) => {
        let fanpageId = props.fanpageId;
        let hears = props.hears[fanpageId];
        let keys = Object.keys(hears);

        if (keys.length === 0) {
            return (
                <DropdownItem>{i18n.t('No data')}</DropdownItem>
            );
        }

        return (
            keys.map(function (key) {
                let hearData = hears[key];
                let hear = hearData['hear'];

                return (
                    <DropdownItem
                        key={key}
                        onClick={(e) => component.selectCallback(e)}
                        value={hear}
                    >
                        {hear}
                    </DropdownItem>
                );
            })
        );
    };

    createInputCallback = () => {
        return (
            <div className="api-input-item">
                <InputGroup>
                    <InputGroupButtonDropdown
                        addonType="prepend"
                        isOpen={this.state.dropdownCallbackOpen}
                        toggle={this.toggleCallback}
                    >
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>{i18n.t("Action") + " " + this.buttonNumber}</InputGroupText>
                        </InputGroupAddon>
                        <DropdownToggle
                            caret
                            color="secondary"
                            id={'button_payload_' + this.props.replyIndex + '_' + this.props.buttonIndex}>
                            {this.callbackString(this.state.buttonPayload)}
                        </DropdownToggle>
                        <DropdownMenu className="dropdownHears">
                            {this.dropdownHears(this, this.props)}
                        </DropdownMenu>
                    </InputGroupButtonDropdown>
                </InputGroup>

                <HearFacebookButtonPayloads
                    fanpageId={this.props.fanpageId}
                    payload={this.state.buttonPayload}
                    hearId={this.props.hearId}
                    button={this}
                />
            </div>
        );
    };

    render() {
        let elements;

        if (this.state.buttonType === HearFacebookButton.WEB_LINK) {
            elements = this.createInputUrl()
        } else {
            elements = this.createInputCallback()
        }

        return (
            <div className="hear-element hear-facebook-button">

                <div className="api-input-item">
                    <InputGroup>
                        <InputGroupButtonDropdown
                            addonType="prepend"
                            isOpen={this.state.dropdownOpen}
                            toggle={this.toggleButtonType}
                        >
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>{i18n.t("Button") + " " + this.buttonNumber}</InputGroupText>
                            </InputGroupAddon>
                            <DropdownToggle
                                caret
                                color="secondary"
                                id={'button_type_' + this.props.replyIndex + '_' + this.props.buttonIndex}>
                                {this.typeString(this.state.buttonType)}
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem header>{i18n.t("Button Type")}</DropdownItem>

                                <DropdownItem
                                    id={'button_type_web_link_' + this.props.replyIndex + '_' + this.props.buttonIndex}
                                    onClick={this.selectButtonType}
                                    value={HearFacebookButton.WEB_LINK}
                                >
                                    {this.typeString(HearFacebookButton.WEB_LINK)}
                                </DropdownItem>

                                <DropdownItem
                                    id={'button_type_postback_' + this.props.replyIndex + '_' + this.props.buttonIndex}
                                    onClick={this.selectButtonType}
                                    value={HearFacebookButton.POSTBACK}
                                >
                                    {this.typeString(HearFacebookButton.POSTBACK)}
                                </DropdownItem>
                            </DropdownMenu>
                        </InputGroupButtonDropdown>

                        <Input
                            placeholder={i18n.t("Text of button") + " " + this.buttonNumber}
                            id={'button_text_' + this.props.replyIndex + '_' + this.props.buttonIndex}
                            onChange={this.handleTextChange}
                            value={this.state.buttonText}
                            invalid={this.state.buttonTextInvalid}
                            valid={this.state.buttonTextValid}
                        />
                    </InputGroup>
                </div>

                {elements}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        hears: state.HearsReducer
    }
};

export default connect(mapStateToProps, {})(HearFacebookButton);

